import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19 6.843h-1V.977C18 .391 17.6 0 17 0H5c-.6 0-1 .39-1 .977v5.866H3c-1.7 0-3 1.27-3 2.932v4.888c0 1.662 1.3 2.933 3 2.933h1v2.933c0 .587.4.978 1 .978h12c.6 0 1-.392 1-.978v-2.933h1c1.7 0 3-1.27 3-2.932V9.775c0-1.661-1.3-2.932-3-2.932M6 1.955h10v4.888H6zm10 17.596H6v-5.865h10zm4-4.888c0 .587-.4.978-1 .978h-1v-2.933c0-.586-.4-.977-1-.977H5c-.6 0-1 .39-1 .977v2.933H3c-.6 0-1-.391-1-.978V9.776c0-.587.4-.978 1-.978h16c.6 0 1 .391 1 .977z"
    }, null, -1)
  ]))]))
}
export default { render: render }